<template>
	<section class="container container_main-content claim">
		<h2 class="heading heading-subtitle">Dokonalé oholení</h2>
		<h1 class="heading heading-title">Perfektní střih</h1>
		<div class="icon__divider">
			<span class="icon icon__divider-outer">
				<span class="icon icon__divider-inner"></span>
			</span>
		</div>
		<article class="article article__content">
			<ul class="article__content-item article__content-item-primary">
				<li v-for="(claim, i) in claims" :key="i">
					<h4 class="heading heading-content-title">{{ claim.title }}</h4>
					<p class="content-default">{{ claim.content }}</p>
				</li>
			</ul>
			<div class="article__content-item article__content-item-secondary image article__image">
				<img src="" alt="" />
			</div>
		</article>
		<router-link :to="{ name: 'services' }" class="button button-big button-big-yellow centered">
			{{ $t('pages.services') }}
		</router-link>
	</section>
</template>

<script>
export default {
	data() {
		return {
			claims: [
				{
					title: '1. Parádní střih',
					content: 'Ať se rozhodneš pro klasický, moderní nebo extravagantní střih, odejdeš vždy perfektně upraven.',
				},
				{
					title: '2. Vousy jako v bavlnce',
					content: 'Extra péče pro pěstěný plnovous, upravit kontury nebo oholit do hladka? Všechno k tvé naprosté spokojenosti.',
				},
				{
					title: '3. Blízko z domu i kanceláře',
					content: 'Budeš to k nám mít kousek ať jedeš autem nebo MHD, zastávku máme za rohem, parkování přímo u dveří.',
				},
			],
		}
	},
}
</script>
